import React from 'react'
import { useNavigate } from 'react-router' ;
import { useSelector } from 'react-redux';
import {
    PlusOutlined,
} from '@ant-design/icons';
import {
    Tooltip
} from "antd";

// Components
import RuleEngineTable from './components/RuleEngineTable'
import { PrimaryButton } from "../../../../components/Decoration/Button";

// Services Library
import { REDUX } from "../../../../services/util"

const RuleEnginePanel = () => {

    const navigate = useNavigate()

    const ruleTemplateIDs = useSelector(REDUX.reduxStoreWrapper('ruleTemplates.allIDs'))

    const AddRuleTemplateOnClick = () => {
        navigate(`/create/ruletemplate`)
    }

    const AddRuleOnClick = () => {
        navigate(`/create/rule`)
    }
  
    const disabled = ruleTemplateIDs.length === 0

    return (
        <div style = {{ display: "flex", flex: 1 }}>
            <div
                className = "scroll-div"
                style = {{
                    width: "95%",
                    margin: "0 5%"
                }}
            >
                <div
                    style = {{
                        display: "flex",
                        justifyContent: "flex-end",

                        padding: 5,
                        marginBottom: 10,
                    }}
                >
                    <PrimaryButton 
                        icon = {<PlusOutlined/>} 
                        onClick = {AddRuleTemplateOnClick}
                    >
                        Add New Rule Group
                    </PrimaryButton>

                    <Tooltip
                        placement = "top"
                        title = {`No custom rule template found. Add a new rule template first`}
                        open = {disabled}
                    >
                        <PrimaryButton
                            disabled = {disabled}
                            icon = {<PlusOutlined/>}
                            onClick = {AddRuleOnClick}
                            style = {{ marginLeft: 10 }}
                        >
                            Add New Rule
                        </PrimaryButton>
                    </Tooltip>
                </div>

                <>
                    <RuleEngineTable />
                </>
            </div>
        </div>
    )
}

export default RuleEnginePanel